import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { SipDevice } from '@ragu-components/ord-types';

const SipDevicesList = React.lazy(async () => import('./SipDevicesList'));

export const sipDevicesResource: OrdResourceProps = {
  key: Resources.sip_devices,
  name: Resources.sip_devices,
  list: <SipDevicesList />,
  options: {},
  recordRepresentation: (record: SipDevice) => record.mac_address,
};
